import React from 'react';
import { proofNote, stats, universities } from '../data/content';
export function ProofBar() {
  return <section className="w-full bg-blue-50 py-14 md:py-20" data-id="element-138" data-mp="ma8ap3vb8xf0">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-139" data-mp="mbt4gr9swcbt">
        <dl className="grid grid-cols-2 gap-8 text-center md:grid-cols-4" data-id="element-140" data-mp="7kj6t0vu2fb1">
          {stats.map(stat => <div key={stat.label} className="flex flex-col-reverse" data-id="element-141" data-mp="cicc7rpbb5a9">
              <dt className="mx-auto mt-1 block max-w-[14rem] text-sm font-semibold text-blue-700" data-id="element-142" data-mp="3uoqlvegjst2u">
                {stat.label}
              </dt>
              <dd className="text-4xl font-extrabold tracking-tight text-slate-900 md:text-5xl" data-id="element-143" data-mp="3h4ebaqpk6gp">
                {stat.value}
              </dd>
            </div>)}
        </dl>

        <div className="mt-12 border-t border-blue-200/70 pt-8 text-center" data-id="element-144" data-mp="3psrsfcgd4kvk">
          <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-blue-600" data-id="element-145" data-mp="1j0r0ectaegak">
            {proofNote}
          </p>
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-3" data-id="element-146" data-mp="1nwy8oc95o3vo">
            {universities.map(university => <li key={university} className="rounded-full bg-white px-4 py-1.5 text-sm font-extrabold tracking-tight text-blue-800 ring-1 ring-blue-200" data-id="element-147" data-mp="2ngdl9o9t1a8b">
                {university}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}